var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WEB LOGOS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 6.40039L22.2892 26.4004H12.6983L16.9716 18.1115H16.7799C13.2545 22.6968 7.99458 25.7154 0.5 26.4004V18.2263C0.5 18.2263 5.29446 17.9425 8.11298 14.9734H0.5V6.40055H9.05618V13.4516L9.24821 13.4508L12.7446 6.40055H19.2154V13.4069L19.4074 13.4066L23.0349 6.40039H32.5Z",
    fill: "#146EF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflow);
export default __webpack_public_path__ + "static/media/webflow.894733ea341c98a0a48b7b042c74f62d.svg";
export { ForwardRef as ReactComponent };